import { find, isNull, lowerCase } from 'lodash-es';

import { NetSheetNameValuePair } from '../typings/net-sheet';

export function findOption(list: NetSheetNameValuePair[], value: string | null) {
  let result: NetSheetNameValuePair | undefined;
  if (!isNull(value)) {
    result = find(list, (item) => lowerCase(item.value) === lowerCase(value));
  }
  return result;
}
